import 'iziModal';
import $ from 'jquery';

class Modal {
    constructor(el) {
        this.el = el;
        this.el.iziModal({
            iframe: this.el.hasClass('modal--iframe'),
            iframeHeight: $(window).height() * 0.6,
        });

    }


}

export default Modal;